import { Injectable, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';

import { ArableAdviceValidationErrorResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class TranslationHelpers {
  private readonly locale = inject(LocaleService);


  /**
   * Generates a localised validation text based on the error object and the validation object path
   *
   * @param error - the error object
   * @param validationObjectPath - the path to the validation object, e.g. fertilizationBalance.validation
   * @returns the generated validation text
   */
  generateLocalisedValidationText(error: ArableAdviceValidationErrorResponse, validationObjectPath: string): string {
    let validationText = '';
    console.log('error', error);
    if (error.validationMessageCodes?.length) {
      for (const errorCode of error.validationMessageCodes) {
        validationText += this.locale.translate(`${validationObjectPath}.${errorCode}`) + '\n';
      }
    } else {
      validationText = 'Something went wrong, try again later';
    }
    return validationText;
  }
}
